import { Checkbox, FormControlLabel } from "@mui/material";
import DeterminateDateRangeInput from "features/dateRange/DeterminateDateRangeInput";
import { type Filters } from "../useTimeEntrySearch";
import { useGetAllOfficesQuery } from "app/api/offices";
import { useGetAllDepartmentsQuery } from "app/api/departments";
import MultiSelect from "components/MultiSelect";
import { TimeEntryTypes } from "models/TimeEntry";
import { useAuthContext } from "features/auth/AuthContext";

type TimeEntryFiltersProps = {
  filters: Filters;
  onChange: (filters: Filters) => void;
};

const TimeEntryFilters: React.FC<TimeEntryFiltersProps> = (props) => {
  const { filters, onChange } = props;
  const { user } = useAuthContext();
  const isAdminOrPayroll = user?.role === "ADMIN" || user?.role === "PAYROLL";
  const { fromDate, toDate, states, types, processed, officeIds, departmentIds } = filters;

  const { data: offices } = useGetAllOfficesQuery();
  const { data: departments } = useGetAllDepartmentsQuery();

  const updateFilters = (newFilters: Partial<Filters>) => {
    onChange({ ...filters, ...newFilters });
  };

  return (
    <>
      <DeterminateDateRangeInput
        startText="Från"
        endText="Till"
        value={[fromDate, toDate]}
        onChange={([fromDate, toDate]) => updateFilters({ fromDate, toDate })}
      />

      {isAdminOrPayroll && (
        <>
          <MultiSelect
            label="Typ"
            value={types ?? []}
            onChange={(value) => updateFilters({ types: value?.length ? value : null })}
            options={[
              { id: TimeEntryTypes.SickLeave, name: "Sjuk" },
              { id: TimeEntryTypes.PaidVacation, name: "Betald semester" },
              { id: TimeEntryTypes.ChildCare, name: "VAB" },
              { id: TimeEntryTypes.UnpaidVacation, name: "Tjänstledigt" },
              { id: TimeEntryTypes.Overtime, name: "Övertid" },
              { id: TimeEntryTypes.RelativeCare, name: "Vård av anhörig" },
              { id: TimeEntryTypes.ParentalLeave, name: "Föräldraledig" },
            ]}
          />

          <MultiSelect
            label="Status"
            value={states ?? []}
            onChange={(value) => updateFilters({ states: value?.length ? value : null })}
            options={[
              { id: "PENDING", name: "Ej attesterad" },
              { id: "APPROVED", name: "Godkänd" },
              { id: "REJECTED", name: "Nekad" },
            ]}
          />
        </>
      )}

      <MultiSelect
        label="Avdelningar"
        value={departmentIds ?? []}
        onChange={(value) => updateFilters({ departmentIds: value?.length ? value : null })}
        options={
          departments?.map((department) => ({ id: department.id, name: department.name })) ?? []
        }
      />

      <MultiSelect
        label="Kontor"
        value={officeIds ?? []}
        onChange={(value) => updateFilters({ officeIds: value?.length ? value : null })}
        options={offices?.map((office) => ({ id: office.id, name: office.name })) ?? []}
      />

      {isAdminOrPayroll && (
        <FormControlLabel
          control={<Checkbox />}
          label="Ej behandlad av ekonomi"
          checked={processed === false}
          onChange={() => updateFilters({ processed: processed === false ? null : false })}
        />
      )}
    </>
  );
};

export default TimeEntryFilters;
